import * as actionType from "./ActionTypes";


export default function ContainerswapdataReducer(state = {}, action) {
    const { payload } = action;
    switch (action.type) {
      case actionType.CONTAINER_SWAP_DATA:
        return (state = payload);  
        default:
        return state;
}

}
